import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { ThumbnailBig, FooterSection } from '@components'
import './ListStructureCorporate.scss'
import { StructureCorporateAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { useParams } from 'react-router-dom'
import Menu from '../Menu'
import ProfileBox from '../../../common/components/ProfileBox'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const CorporateGovernanceContainer = styled.div`
  background-color: #fff;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const PdfLink = styled.a`
  text-decoration: none;
  color: #337ab7;
  font-style: italic;
  font-size: 13px;
`

const sectionTitle = {
  fontFamily: 'KBFGDisplay',
  fontWeight: 'bold',
  fontSize: '24px',
  lineHeight: '36px',
  color: 'rgb(94, 81, 77)',
}

const ListStructureCorporate = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState({
    title: '',
    description: '',
    imageDesktop: '',
  })
  const [isLoading, setisLoading] = useState(false)
  const [shortDesc, setShortDesc] = useState(null)

  const { id } = useParams()
  const active = [
    'komisaris',
    'direksi',
    'komite',
    'sekretarisperusahaan',
    'struktur-organisasi',
  ].indexOf(id)

  useEffect(() => {
    loadData()

    if (!shortDesc) {
      loadShortDescData()
    }
  }, [shortDesc])

  const paramShortDesc = (paramId) => {
    switch (paramId) {
      case 'komisaris':
        return `komisaris`
      case 'direksi':
        return `direksi`
      case 'komite':
        return `komite`
      case 'sekretarisperusahaan':
        return `sekretaris_perusahaan`
      case 'struktur-organisasi':
        return `struktur_organisasi`
      default:
        return
    }
  }

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: paramShortDesc(id) })
    setShortDesc(data.data)
  }

  const loadData = async function () {
    setisLoading(true)
    const { data } = await StructureCorporateAPI(id)
    if (data.data != null) {
      setdata(data.data)
      setisLoading(false)
    }
  }

  return (
    <div>
      <TitleComponent title={data.title || data.judulSO} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={shortDesc !== null ? shortDesc[0].title : ''}
            desc={shortDesc !== null ? shortDesc[0].description : ''}
            img={shortDesc !== null ? shortDesc[0].banner : ''}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={shortDesc !== null ? shortDesc[0].title : ''}
            desc={shortDesc !== null ? shortDesc[0].description : ''}
            img={shortDesc !== null ? shortDesc[0].banner : ''}
          />
        </Mobile>
      </Container>
      {/* {id === "struktur-organisasi" ? (
        <Container>
          <Desktop>
            <ThumbnailBig
              title={shortDesc !== null ? shortDesc[0].title : ""}
              desc={shortDesc !== null ? shortDesc[0].description : ""}
              img={shortDesc !== null ? shortDesc[0].banner : ""}
            />
          </Desktop>
          <Mobile>
            <ThumbnailBig
              title={shortDesc !== null ? shortDesc[0].title : ""}
              desc={shortDesc !== null ? shortDesc[0].description : ""}
              img={shortDesc !== null ? shortDesc[0].banner : ""}
            />
          </Mobile>
        </Container>
      ) : (  
        <Container>
          <Desktop>
            <ThumbnailBig
              title={isLoading ? "" : data.title || data.judulSO}
              desc={isLoading ? "" : data.description}
              img={isLoading ? "" : data.imageDesktop || data.imageDesktopSO}
            />
          </Desktop>
          <Mobile>
            <ThumbnailBig
              title={isLoading ? "" : data.title || data.judulSO}
              desc={isLoading ? "" : data.description}
              img={isLoading ? "" : data.imageMobile || data.imageMobileSO}
            />
          </Mobile>
        </Container>
      )} */}

      <CorporateGovernanceContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex position-relative row">
            <div className="col-lg-9 col-12">
              {typeof data.blockData != 'undefined' &&
                data.blockData.map((item, index) => (
                  <div>
                    <Desktop>
                      <ProfileBox
                        nama={item.nama}
                        jabatan={item.jabatan}
                        description={item.deskripsiData}
                        imageDataDesktop={item.imageDataDesktop}
                      />
                    </Desktop>
                    <Mobile>
                      <ProfileBox
                        nama={item.nama}
                        jabatan={item.jabatan}
                        description={item.deskripsiData}
                        imageDataDesktop={item.imageDataMobile}
                      />
                    </Mobile>
                  </div>
                ))}

              {id === 'struktur-organisasi' && (
                <div>
                  <div className="mb-4">
                    <p style={sectionTitle}>{data.judulSO}</p>
                    <Desktop>
                      <img src={data.imageDesktopSO} width="100%" />
                    </Desktop>
                    <Mobile>
                      <img src={data.imageMobileSO} width="100%" />
                    </Mobile>
                    <div className="mt-1">
                      <PdfLink
                        href="https://www.bukopin.co.id/assets/images/Organization%20Structure_main0025-2022_corsec.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Klik Gambar untuk melihat versi PDF
                      </PdfLink>
                    </div>
                  </div>
                  <div className="mb-4">
                    <p style={sectionTitle}>{data.judulKU}</p>
                    <Desktop>
                      <img src={data.imageDesktopKU} width="100%" />
                    </Desktop>
                    <Mobile>
                      <img src={data.imageMobileKU} width="100%" />
                    </Mobile>
                    <div className="mt-1">
                      <PdfLink
                        href="https://www.bukopin.co.id/assets/images/Struktur%20Organisasi%20KB%20Bukopin%202022.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Klik Gambar untuk melihat versi PDF
                      </PdfLink>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="d-none d-lg-block col">
              <Menu active={active} />
            </div>
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t(id)} />
    </div>
  )
}

export default ListStructureCorporate
